import { render, staticRenderFns } from "./EditGoal.vue?vue&type=template&id=055d6024"
import script from "./EditGoal.vue?vue&type=script&lang=js"
export * from "./EditGoal.vue?vue&type=script&lang=js"
import style0 from "./EditGoal.vue?vue&type=style&index=0&id=055d6024&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports